<template>
  <div class="chart-container">
    <!-- 标题区域 -->
    <div v-if="title" ref="titleArea" class="title-container">
      <h4 :style="{ ...titleStyle }" class="title">{{ title }}</h4>
      <!--<a-button v-if="showReturnBtn" type="primary" @click="handleReturn">返回上级</a-button>-->
      <div class="flex-align-center">
        <a-button v-if="showAvgBtn" class="avg-btn" type="primary" @click="setAvgLine">
          {{ showAvgLineStatus ? '关闭平均值' : '显示平均值' }}
        </a-button>
        <slot name="titleExtra"></slot>
      </div>
    </div>
    <!-- 图表区域 -->
    <div
      ref="chart"
      :style="{ width: '100%', height: height, ...chartStyle }"
      class="chart"
      @click="chartClick"
    ></div>
    <!--    曲线平均值或总值区域-->
    <Transition name="avg">
      <div v-if="showAvgLineStatus" class="avg-sum-container">
        <div v-for="(item, index, key) in avgOrSumArr" :key="index">
          <div class="title-2" style="margin-top: 5px">{{ item.month }}</div>
          <div class="flex-align-center" style="flex-wrap: wrap; margin-left: 20px">
            <template v-for="(value, key) in item" v-if="key != 'month'">
              <span class="key-item">
                <span>{{ key }}：</span>
                <span>{{ value }}</span>
              </span>
            </template>
          </div>
        </div>
      </div>
    </Transition>

    <!--    底部现象和建议区域-->
    <slot name="bottomExpandArea">
      <div v-if="showBottomExpandArea && markdownText" class="bottom-expand-area">
        <MarkdownIt v-if="markdownText" :content="markdownText" />
      </div>
    </slot>
    <!-- 标注区域 -->
    <div v-if="markList && markList.length > 0">
      <img
        v-for="(item,index) in markList"
        :key="index"
        :src="item.image"
        :style="{
          position: 'absolute',
          left: item.position[0] - 1 + 'px',
          top: item.position[1] - 4 + 'px',
        }"
        alt=""
        class="img-appear"
        @click="(e) => lineMarkerClick(e, item)"
      />
    </div>
    <!-- 标注提示弹框 -->
    <div v-if="tipStatus">
      <div ref="tipModal" :style="tipStyle" class="tip-modal animate__animated animate__bounceIn">
        <!-- 具名插槽 -->
        <slot :record="guideTipList" name="guideTipModal">
          <template v-if="guideTipList.length">
            <div
              v-for="(item, index) in guideTipList"
              :key="index"
              style="width: 100%; margin-bottom: 10px"
            >
              <div class="tip-head">
                <span
                  :class="
                    item.type == 'warn'
                      ? 'warn-title'
                      : item.type == 'intervene'
                      ? 'intervene-title'
                      : ''
                  "
                  class="tip-title"
                >
                  {{ item.title }}
                </span>
                <span class="tip-time">{{ item.time }}</span>
              </div>
              <div class="tip-desc">{{ item.desc }}</div>
            </div>
          </template>
          <template v-else>
            <EmptyData :styleObj="{ width: '100%', height: '100%' }" />
          </template>
        </slot>
      </div>
      <div class="tip-mask" @click="() => (tipStatus = false)">关闭</div>
    </div>
  </div>
</template>

<script>
import { echartBaseMixin, lineMixin } from '../mixins'
import MarkdownIt from '@/components/MarkdownIt'
import moreEvent from '@/assets/schoolChangeTrend/moreEvent.png'
import positionIcon from '@/assets/schoolChangeTrend/positionIcon.png'
import warnIcon from '@/assets/schoolChangeTrend/warn-icon.png'
import interveneIcon from '@/assets/schoolChangeTrend/interveneIcon.png'
import { getAction } from '@api/manage'
import { getGroupAvgOrSum, sortArrObj } from '@/utils/util'
import { getMonthGroup } from '@/utils/date'
import moment from 'moment'

export default {
  name: 'LineChart',
  mixins: [echartBaseMixin, lineMixin], // 混合
  components: {
    MarkdownIt,
  },
  props: {
    smooth: {
      type: Boolean,
      default: true,
    },
    showReturnBtn: {
      type: Boolean,
      default: false,
    },
    yAxisMultiple: {
      type: [Number, String],
      default: 1.2,
    },
    // 是否显示平均线
    showAvgBtn: {
      type: Boolean,
      default: false,
    },
    // 是否显示底部贴地标识
    showBottomMark: {
      type: Boolean,
      default: false,
    },
    // 自定义标注图片函数
    markImgFormatFunc: {
      type: Function,
      default: () => {
        return (params) => {
          let img = ''
          const lineName = params.seriesName
          const currIncidfent = params?.[lineName + 'incident']
            ? String(params[lineName + 'incident'])
            : ''
          if (!lineName || currIncidfent.includes('0')) return ''
          if (currIncidfent.length == 1 && currIncidfent.includes('8')) {
            img = warnIcon
          } else if (currIncidfent.length == 1 && currIncidfent.includes('9')) {
            img = interveneIcon
          } else if (
            currIncidfent.length &&
            !currIncidfent.includes('8') &&
            !currIncidfent.includes('9')
          ) {
            img = positionIcon
          } else if (
            currIncidfent.length > 1 &&
            (currIncidfent.includes('8') || currIncidfent.includes('9'))
          ) {
            img = moreEvent
          }
          return img
        }
      },
    },
    // 是否展示底部扩展区域
    showBottomExpandArea: {
      type: Boolean,
      default: false,
    },
    // y轴数值是否显示为整数
    yAxisInteger: {
      type: Boolean,
      default: false,
    },
    // y轴分割线数量
    yAxisSplitNumber: {
      type: Number,
      default: 5,
    },
    // 额外参数
    attrs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      options: {
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: [],
            type: 'line',
          },
        ],
        legend: {},
      },
      // 存储折线图完整数据
      currSeries: [],
      markList: [],
      tipStatus: false,
      windowViewWidth: window.innerWidth,
      tipStyle: {
        width: '142px',
        minHeight: '74px',
        position: 'absolute',
        background: '#fff',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
        padding: '10px',
        cursor: 'pointer',
        zIndex: 999,
        borderRadius: '4px',
      },
      guideTipList: [],
      eventsTypeOpts: [
        {
          label: '心理辅导',
          value: '1',
        },
        {
          label: '班级考试',
          value: '2',
        },
        {
          label: '班级活动',
          value: '3',
        },
        {
          label: '年级活动',
          value: '4',
        },
        {
          label: '校园活动',
          value: '5',
        },
        {
          label: '工作会议',
          value: '6',
        },
        {
          label: '其他',
          value: '7',
        },
      ],
      showAvgLineStatus: false,
      markdownText: '', // 底部建议富文本
      avgOrSumArr: [], // 平均值或总值数组
    }
  },
  created() {
    this.initOptionConfig()
  },
  watch: {
    dataSource: {
      handler(val) {
        // console.log('lineChart数据源更新--', val)
        if (this.showAvgBtn) {
          const res = getMonthGroup(val)
          this.avgOrSumArr = getGroupAvgOrSum(res, this.fields)
        }
        this.getXAxis(val)
        this.setLegend()
        this.setLineSeriesData(val)
        this.updateYAxisConfig(val)
        if (this.chartInstance) {
          // 延迟操作，防止拿到错误的位置信息
          setTimeout(() => {
            this.addImageMarkers()
          }, 10)
        }
        console.log('this.options', this.options)
        this.renderChart()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initOptionConfig() {
      this.options = {
        tooltip: this.tooltip,
        grid: this.grid,
        toolbox: this.toolbox,
        ...this.options,
        ...this.attrs,
      }
      // console.log('初始化配置：', this.options)
      if (!this.title && this.defaultTitle) {
        this.$set(this.options, 'title', this.defaultTitle)
      }
      if (this.color?.length) {
        this.$set(this.options, 'color', this.color)
      }

      // 设置y轴基础配置
      this.updateYAxisConfig(this.dataSource)
    },
    updateYAxisConfig(data) {
      const yAxisConfig = {}

      // 处理数据范围小的情况，避免重复显示相同的刻度值
      const allValues = []
      if (data && data.length > 0) {
        this.fields.forEach((field) => {
          data.forEach((item) => {
            if (item[field] !== undefined && item[field] !== null) {
              allValues.push(item[field])
            }
          })
        })
      }

      // 如果存在数据，计算固定的间隔以确保最多显示指定数量的分割线
      if (allValues.length > 0) {
        const min = Math.min(...allValues)
        const max = Math.max(...allValues)

        // 计算合适的最小值和最大值（确保为整数）
        let yAxisMin = 0 // 强制最小值为0
        let yAxisMax = Math.max(1, Math.ceil(max))

        // 如果数据范围很小，设置固定的最小值和最大值
        if (max - min <= 1) {
          yAxisMin = 0
          yAxisMax = Math.max(1, Math.ceil(max))
        } else {
          // 扩大范围以确保数据不会贴在边界上（确保为整数）
          const range = max - min
          yAxisMin = Math.floor(min - range * 0.1)
          yAxisMax = Math.ceil(max + range * 0.1)
        }

        // 确保最小值不小于0
        yAxisMin = Math.max(0, yAxisMin)

        // 计算间隔，确保最多显示 yAxisSplitNumber 条分割线，且间隔为整数
        const rawInterval = (yAxisMax - yAxisMin) / this.yAxisSplitNumber
        const interval = Math.ceil(rawInterval)

        // 重新调整 yAxisMax，确保能被 interval 整除
        yAxisMax = yAxisMin + interval * this.yAxisSplitNumber

        yAxisConfig.min = yAxisMin
        yAxisConfig.max = yAxisMax
        yAxisConfig.interval = interval
      } else {
        // 没有数据时，使用 splitNumber 作为建议值
        yAxisConfig.splitNumber = this.yAxisSplitNumber
      }

      // 设置y轴数值为整数
      if (this.yAxisInteger) {
        yAxisConfig.axisLabel = {
          formatter: function (value) {
            return Math.round(value)
          },
        }
      }

      // 应用Y轴配置
      this.$set(this.options, 'yAxis', { ...this.options.yAxis, ...yAxisConfig })
    },
    getXAxis(data) {
      const xData = data.length && [...new Set(data.map((item) => item.type))]
      this.$set(this.options.xAxis, 'data', xData)
      console.log('xData', xData)
      return xData
    },
    bottomMarkSetFunc(picStatusArr) {
      return this.showBottomMark
        ? {
            // symbol: function (_, params) {
            //   // 动态设置符号
            //   return picStatusArr[params.dataIndex] == 1 ? 'circle' : 'emptyCircle'
            // },
            // 动态设置点大小
            symbolSize: function (_, params) {
              return picStatusArr[params.dataIndex] == 1 ? 6 : 4
              // return params.dataIndex == 1 ? 6 : 4
            },
            itemStyle: {
              color: function (params) {
                // 设置点颜色
                return picStatusArr[params.dataIndex] == 1 ? '#ff0000' : params.color
              },
            },
          }
        : {}
    },
    // 处理数据源
    setLineSeriesData(data) {
      // console.log('处理数据结构：', data)
      if (this.fields.length && this.type == 'line') {
        const seriesData = this.fields.map((field) => {
          const bottomMarkSet = this.bottomMarkSetFunc(
            data.map((item) => item[field + 'picStatus'])
          )
          const seriesItem = {
            name: field,
            type: 'line',
            smooth: this.smooth,
            data: data.map((item) => item[field]),
            markLine: this.showAvgLineStatus && {
              // 平均线
              data: [{ type: 'average', name: 'Avg' }],
              // symbol: 'none',
            },
            ...bottomMarkSet,
          }
          return seriesItem
        })
        this.currSeries = seriesData
        this.$set(this.options, 'series', seriesData)
        return seriesData
      }
    },
    // 添加图片标注
    addImageMarkers() {
      const markers = []
      this.$set(this.options, 'graphic', { elements: [] })
      // this.setYMax()
      this.options.series.forEach((series, seriesIndex) => {
        series.data.forEach((value, index) => {
          if (value == undefined && value == null) return
          const currX = this.options.xAxis.data[index]
          const dataPointX = this.chartInstance.convertToPixel('xAxis', currX)
          const dataPointY = this.chartInstance.convertToPixel('yAxis', value)
          const pointData = this.findCurrPointData(currX, series.name)
          // console.log('点信息：', pointData)

          const imgType = this.markImgFormatFunc()(pointData) // 柯里化函数
          if (!imgType) return
          const titleAreaHeight = this.$refs.titleArea && this.$refs.titleArea.offsetHeight
          // 添加标注
          markers.push({
            type: 'image',
            id: pointData[series.name + 'id'],
            periodId: pointData[series.name + 'periodId'],
            incident: pointData[series.name + 'incident'],
            realtime: pointData[series.name + 'realtime'],
            // warn: pointData[series.name + 'warn'],
            x: currX,
            y: series.name,
            image: imgType,
            style: {
              image: imgType, // 图片 URL
              width: 20, // 图片宽度
              height: 20, // 图片高度
            },
            position: [
              dataPointX - 12,
              titleAreaHeight ? dataPointY - 28 + titleAreaHeight : dataPointY - 28,
            ], // 标注位置
          })
        })
      })
      // 将标记添加到图表
      // console.log('添加标注所有点--', markers)
      this.markList = markers
    },
    // setYMax() {
    //   let allYValue = []
    //   this.options.series.forEach((item) => {
    //     allYValue.push(...item.data)
    //   })
    //   allYValue = allYValue.filter((item) => item != undefined && item != null)
    //   const maxYValue = Math.round(Math.max(...allYValue))
    //   this.$set(this.options.yAxis, 'max', maxYValue * this.yAxisMultiple)
    //   this.renderChart()
    // },
    // 点击标注按钮
    async lineMarkerClick(e, record) {
      // console.log('点击标注：', record)
      const markTipList = await this.getGuideEventTip(record.periodId, record.realtime)
      this.tipStatus = true
      this.guideTipList = sortArrObj(markTipList)
      // 等弹框渲染出真实宽高后再定位
      this.$nextTick(() => {
        this.setTipPosition(record.position)
      })
      this.$emit('lineMarkerClick')
    },
    // 弹框定位：默认显示在标注点正上方（水平居中），上方空间不足则翻到下方，左右夹紧不溢出容器
    setTipPosition([x, y]) {
      const containerWidth = this.$el.clientWidth
      const tipWidth = this.$refs.tipModal?.offsetWidth || 200
      const tipHeight = this.$refs.tipModal?.offsetHeight || 74
      // 标注图标宽 28，取它的水平中心作为对齐基准
      const centerX = x + 14
      let left = Math.max(0, Math.min(centerX - tipWidth / 2, containerWidth - tipWidth))
      let top = y - tipHeight - 16
      // 顶部空间不够，放到标注点下方
      if (top < 0) {
        top = y + 34
      }
      this.$set(this.tipStyle, 'left', left + 'px')
      this.$set(this.tipStyle, 'top', top + 'px')
    },
    async getGuideEventTip(id, date) {
      const res = await getAction('/dataEvents/queryByEventIdAndDate', {
        eventsId: id,
        eventTimePeriod: date,
      })
      const mapTipData =
        res.success && res.result.length
          ? res.result.map((item) => {
              return {
                title:
                  item.eventsType == '8'
                    ? '小叮当提醒'
                    : item.eventsType == '9'
                    ? '小叮当干预'
                    : this.eventsTypeOpts.find((opt) => opt.value == item.eventsType)?.label,
                time: item.createTime
                  ? moment(item.createTime).format('YYYY-MM-DD HH:mm')
                  : item.eventTimePeriod,
                desc: item.eventsContent,
                type:
                  item.eventsType == '8' ? 'warn' : item.eventsType == '9' ? 'intervene' : 'event',
              }
            })
          : []
      return mapTipData
    },
    // 设置平均值
    setAvgLine() {
      this.showAvgLineStatus = !this.showAvgLineStatus
      const seriesData = this.options.series.map((item) => ({
        ...item,
        markLine: this.showAvgLineStatus && {
          // 平均线
          data: [{ type: 'average', name: 'Avg' }],
          // symbol: 'none',
        },
      }))
      console.log('数据源2：', seriesData)
      this.$set(this.options, 'series', seriesData)
      this.renderChart()
    },
    // 图表点击事件
    async chartClick() {
      // if (this.markdownText) return
      if (!this.attrs?.studentId) return
      const xAxisData = this.options.xAxis.data
      const date = xAxisData[xAxisData.length - 1]
      // const res = await getAction('/statistic/curveComments', {
      //   studentId: this.attrs.studentId,
      //   date,
      // })
      // if (res.success) {
      //   this.markdownText = `### **${date}** \n ${res.result.aiExplain || '暂无评语数据'}`
      // }
    },
  },
}
</script>

<style lang="less" scoped>
.chart-container {
  position: relative;

  .img-appear {
    width: 28px;
    height: auto;
    animation: appearShake 0.3s linear;
  }

  @keyframes appearShake {
    0% {
      opacity: 0.7;
      transform: scale(0.8);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  .title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }

  .tip-modal {
    min-width: 200px;

    .tip-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .tip-title {
      font-size: 14px;
      display: inline-block;
      color: #fff;
      background: #13b999;
      padding: 0 4px;
      border-radius: 4px;
      font-size: 12px;
    }

    .warn-title {
      background: #fa3a25;
    }

    .intervene-title {
      background: #ff9d3a;
    }

    .tip-time {
      font-size: 12px;
    }

    .tip-desc {
      width: 100%;
      margin-top: 6px;
      display: inline-block;
      font-size: 12px;
      white-space: wrap;
      word-wrap: break-word;
    }
  }

  .tip-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    z-index: 99;
  }

  /deep/ .ant-empty {
    .ant-empty-image {
      transform: scale(0.6);
    }
  }
}

.chart {
  width: 100% !important;
}

.avg-btn {
  margin-right: 15px;
  background-color: #ffffff;
  color: #1890ff;
  border-color: #1890ff;
  text-shadow: none;
  box-shadow: none;
}

.bottom-expand-area {
  max-height: 160px;
  overflow-y: auto;
  background-color: #f9f9f9;
  border-radius: 6px;
  padding: 15px 20px;
  margin-top: 20px;
  color: #262626;
  line-height: 1.8;
  animation: expandArea 0.3s ease-in-out;

  /deep/ .markdown-renderer {
    p {
      margin-bottom: 0 !important;
    }
  }
}

@keyframes expandArea {
  0% {
    transform: scale(0.2) translate(-50%, -100%);
    height: 0;
  }
  100% {
    transform: scale(1) translate(0, 0);
    height: auto;
  }
}

.avg-sum-container {
  max-height: 160px;
  overflow-y: auto;
  margin-top: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 6px;

  .key-item {
    margin-right: 15px;
    line-height: 2.2;
    //去掉最后一个元素的margin-right
    //&:last-child {
    //  margin-right: 0;
    //}
  }
}

.avg-enter-active {
  animation: expandArea 0.3s;
}

.avg-leave-active {
  animation: expandArea 0.3s reverse;
}
</style>
